import { render, staticRenderFns } from "./DashboardReminder.vue?vue&type=template&id=07d623b8&"
import script from "./DashboardReminder.vue?vue&type=script&lang=js&"
export * from "./DashboardReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports